//import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk';
import logger from 'redux-logger';

import { configureStore } from '@reduxjs/toolkit'

import reducers from './state';

// Create a safe storage that handles SSR
const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

// Use localStorage when available (client-side), noop storage during SSR
const storage = typeof window !== 'undefined' && window.localStorage 
  ? require('redux-persist/lib/storage').default 
  : createNoopStorage();

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['fleets', 'user', 'uiPreferences'],
  // Add serialize option to prevent issues during SSR
  serialize: typeof window !== 'undefined',
  // Disable persistence during SSR
  debug: false,
};

const persistedReducer = persistReducer(persistConfig, reducers);

//const middleware =
//  process.env.NODE_ENV === 'development' ? [thunk, logger] : [thunk];

// createStore gets called twice (I think due to SSR), so we need to make sure that persistor
// is initialized only once, because otherwise the Redux store gets persisted/rehydrated
// multiple times (e.g. when reloading a page), and the Redux state is lost.
let persistor;

const preloadedState = (preloadedState = {}) => {
    //const store = createStore(persistedReducer, preloadedState, middleware);

    const store = configureStore({
      reducer: persistedReducer,
      middleware: () => { return  process.env.NODE_ENV === 'development' ? [thunk, logger] : [thunk];},
      prelaodedState: preloadedState
    });
  
    if (!persistor) {
      persistor = persistStore(store);
    }
    return { store, persistor };

};

export default preloadedState;


